import { UTCDateMini } from '@date-fns/utc';

export type DateValue = {
  date: Date | null;
  text: string | null;
};

const DEFAULT_VALUE: DateValue = {
  date: null,
  text: null,
};

const parseDateValue = (val: DateValue | string | Date | null): DateValue => {
  if (!val) return DEFAULT_VALUE;
  if (typeof val === 'object' && 'date' in val && 'text' in val) {
    // Convert val.date to UTCDateMini if it's a string or Date
    const date = val.date ? new UTCDateMini(val.date) : null;
    return {
      date,
      text: val.text,
    };
  }
  // Legacy format - convert to DateValue
  if (typeof val === 'string' || val instanceof Date) {
    return {
      date: val ? new UTCDateMini(val) : null,
      text: null,
    };
  }
  return DEFAULT_VALUE;
};

export default parseDateValue;
